












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<GtAvatar>({})
export default class GtAvatar extends Vue {
  @Prop({
    type: String,
    default: '//cdn.jsdelivr.net/npm/gitalk@1/src/assets/icon/github.svg',
  }) readonly defaultSrc!: string

  @Prop({ type: String, default: '' }) readonly src!: string
  @Prop({ type: String, default: '' }) readonly alt!: string
}
